import React, { ClipboardEvent } from 'react';
import { Field as FormikField } from 'formik';
import { FieldAttributes } from 'formik/dist/Field';

import { onInputPast } from './helpers';
import { InputType } from './inputType';

export interface IFieldProps extends Omit<FieldAttributes<any>, 'name' | 'type'> {
  name: string;
  type: InputType;
  disablePasting?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

export const Field = ({ disablePasting, onPaste, placeholder, ...rest }: IFieldProps) => (
  <FormikField
    placeholder={placeholder}
    {...rest}
    onPaste={(event: ClipboardEvent<HTMLInputElement>) =>
      onInputPast(event, onPaste, disablePasting)
    }
  />
);
